import React          from 'react';
import { Observe }         from 'rewire-core';
import NoAccess            from '../main-navigation/NoAccess';
import DefaultSettingsView from './DefaultSettingsView';
import SettingsModel       from './SettingsModel';

const SettingPageView = ({settings}: {settings: SettingsModel}) => {
  React.useEffect(() => {
    if (!settings) return;
    return () => {
      if (settings.editor) settings.editor.close();
    };
  }, []);
  const Editor = settings.SettingsView || DefaultSettingsView;
  return <Editor settings={settings} />;
};

export default React.memo(({ settings }: { settings: SettingsModel | undefined }) =>
  <Observe>{() =>
    !settings
      ? null
      : settings.access
        ? <SettingPageView key={settings.id} settings={settings} />
        : <NoAccess />
  }
  </Observe>);
